import { z, ZodTypeAny } from "zod";

/**
 * Allows a nullable number field to be validated as null when an empty string, but coerced into a number when a value is provided.
 * (This avoids the default behavior of zod, which is to coerce "" into 0)
 */
export const zodNullableNumberPipe = (zodPipe: ZodTypeAny) =>
  z
    .string()
    .transform((value) => (value === "" ? null : value))
    .nullable()
    .refine((value) => value === null || !isNaN(Number(value)))
    .transform((value) => (value === null ? 0 : Number(value)))
    .pipe(zodPipe);
